'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _startsWith = require('ramda/src/startsWith');

var _startsWith2 = _interopRequireDefault(_startsWith);

var _filter = require('ramda/src/filter');

var _filter2 = _interopRequireDefault(_filter);

var _isNil = require('ramda/src/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

var _curry = require('ramda/src/curry');

var _curry2 = _interopRequireDefault(_curry);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Get valid langKey in langs or return defaultLangKey
 * @func
 * @param {[String]} langs allowed lang keys ['en', 'fr', 'pt']
 * @param {String} defaultLangKey default browser language key
 * @returns {String} valid langKey
 */


var getValidLangKey = (0, _curry2["default"])(function (langs, defaultLangKey, langKey) {
  if ((0, _isNil2["default"])(langKey)) {
    return defaultLangKey;
  }

  var currentLangKey = (0, _filter2["default"])(function (l) {
    return (0, _startsWith2["default"])(l, langKey);
  }, langs);
  return currentLangKey[0] || defaultLangKey;
});
exports["default"] = getValidLangKey;